export default "__VITE_ASSET__DtjCsHee__"